import { useMemo } from 'react';
import { MultiStateHook, useMultiState } from './multiState';

/*
 **
 ** ---------> Memorization is VITAL for these <---------------------
 **
 */

export type MultiStateV2Actions<State> = Pick<
  MultiStateHook<State>,
  'dispatch' | 'peek' | 'resetDefault' | 'remove' | 'set' | 'getSetter'
>;

export function useMultiStateV2<State extends object>(
  defaultValues: State,
): [State, MultiStateV2Actions<State>] {
  const { values, ...actions } = useMultiState(defaultValues);

  // Memoizing once because all action methods are stable from `useMultiState`
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const memorizedActions = useMemo(() => actions, []);

  return [values, memorizedActions];
}
